// src/components/Admin/InstitutionCmp/InstitutionProfile/InstitutionPubli.js
import React from "react";
import { Segment, Header } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import "./InstitutionPubli.scss";

export function InstitutionPubli({ url }) {
  const { t } = useTranslation("institutions");
  return (
    <Segment padded>
      <Header as="h3">{t("profile.siteAdLabel")}</Header>
      <div className="iframe-container">
        <iframe
          src={url || "about:blank"}
          title="Institución"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </Segment>
  );
}
